import { render, staticRenderFns } from "./EnviarEmail.vue?vue&type=template&id=3bfa8e44&scoped=true&"
import script from "./EnviarEmail.vue?vue&type=script&lang=js&"
export * from "./EnviarEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa8e44",
  null
  
)

export default component.exports